<h2 mat-dialog-title class="dialog-title">
  <mat-icon>report</mat-icon>
  <span>Tuple Reports</span>
  <button mat-icon-button (click)="load()">
    <mat-icon>refresh</mat-icon>
  </button>

  <span class="spacer"></span>
  <button mat-icon-button (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<mat-dialog-content>
  @if (reporter) {
  <div class="filter-bar">
    <span>Only reports by <strong>{{ reporter.username }}</strong></span>
    <button mat-button (click)="filterBy(null)">
      <mat-icon>close</mat-icon>
      Show all
    </button>
  </div>
  }

  @if (loading) {
  <div class="loading-container">
    <mat-spinner diameter="36"></mat-spinner>
  </div>
  } @else if (reports.length === 0) {
  <div class="empty-state">No tuple reports.</div>
  } @else {
  <table class="reports-table">
    <thead>
      <tr>
        <th>When</th>
        <th>Supplier</th>
        <th>Player</th>
        <th>Buy Now / Bid</th>
        <th>Cards</th>
        <th matTooltip="Distinct suppliers reporting this listing now">Reporters</th>
        <th>Listing</th>
      </tr>
    </thead>
    <tbody>
      @for (r of reports; track r.id) {
      <tr>
        <td>{{ formatDate(r.created_at) }}</td>
        <td>
          <button mat-button class="link" (click)="filterBy(r)" matTooltip="Show only this supplier's reports">
            {{ r.reporter_username }}
          </button>
        </td>
        <td>{{ r.player_name || ('#' + r.player_id) }}</td>
        <td>{{ r.buy_now_price | number }} / {{ r.bid_price | number }}</td>
        <td>{{ r.released_cards }}</td>
        <td>{{ r.live ? r.live_reporters : '—' }}</td>
        <td>
          <span [class]="'status-badge ' + (r.live ? 'status-live' : 'status-lapsed')"
            [matTooltip]="'Listing expires ' + formatDate(r.expires_at)">
            {{ r.live ? 'Live' : 'Expired' }}
          </span>
        </td>
      </tr>
      }
    </tbody>
  </table>
  }

  <mat-paginator [length]="total" [pageIndex]="pageIndex" [pageSize]="pageSize" [pageSizeOptions]="[20, 50, 100]"
    (page)="onPage($event)"></mat-paginator>
</mat-dialog-content>
